// @ts-ignore
/* eslint-disable */
import request from "src/lib/axios";

/** 获取 OSS 临时上传凭证 GET /api/v1/oss/credentials */
export async function OssControllerGetUploadCredentialsV1(options?: {
  [key: string]: any;
}) {
  return request<MyApi.ApiResponseOutputOssCredentialsDto>(
    "/api/v1/oss/credentials",
    {
      method: "GET",
      ...(options || {}),
    }
  );
}
